module.exports = __webpack_public_path__ + "static/media/YB5M06_1.dadae45f.jpg";